import React from "react";
import PopUp from '../../GeneralComponents/PopUp';

/*
This component renders a pop up that is being displayed when user clicks on save project button
It asks the user to save - dont save a project.
*/
const SaveProjectPopUpWindow = props => {
  const {
    openAlert,
    setOpenAlert,
    savedPageClicked
  } = props;

  //  This function is fired when dont save button is clicked.It closes the pop up.
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  //  This function is fired when save button is clicked.It saves all the pages.
  const saveAllPages = () => {

    savedPageClicked();
    setOpenAlert(false);
  };

  return (  
      <PopUp
          openAlert={openAlert}
          setOpenAlert={setOpenAlert}
          handleCancel={handleCloseAlert}
          handleConfirm={saveAllPages}    
          title='Save all pages'
          insideDescription ='Are you sure you want to save all pages?'
          cause='SaveAll'
          confirmText='Save'
          cancelText='Cancel'
      />
    );
  
};

export default SaveProjectPopUpWindow;
